import React from 'react'
import PropTypes from 'prop-types'
import { Link } from '@reach/router'

const TOC = ({ list }) => (
  <div className="flex flex-wrap -mx-3">
    {list.map((item, index) => (
      <div className="flex w-1/2 p-1">
        {item.link.startsWith('#') ? (
          <a
            key={index}
            href={item.link}
            className="flex flex-col w-full p-4 m-1 text-lg text-black transition duration-100 ease-in-out transform border border-gray-400 rounded shadow hover:-translate-y-1 item-shadow focus:no-outline hover:shadow-lg focus:translate-y-1 focus:bg-gray-200"
          >
            <span className="my-1 font-bold leading-none text-gray-800">
              {item.name}
            </span>
          </a>
        ) : (
          <Link
            key={index}
            to={item.link}
            className="flex flex-col w-full p-4 m-1 text-lg text-black transition duration-100 ease-in-out transform border border-gray-400 rounded shadow hover:-translate-y-1 item-shadow focus:no-outline hover:shadow-lg focus:translate-y-1 focus:bg-gray-200"
          >
            <span className="my-1 font-bold leading-none text-gray-800">
              {item.name}
            </span>
          </Link>
        )}
      </div>
    ))}
  </div>
)

TOC.propTypes = {
  list: PropTypes.instanceOf(Array).isRequired,
}

export default TOC
